export default __webpack_public_path__ + "static/apothekenfinder-8d27e4eda743cf58a2a8f5aedc71d2ee.jpg";